import React from "react";
import { Col, Row } from "react-bootstrap";
import FormSection from "./FormSection";
import ItemNumberInput from "./input/ItemNumberInput";
import SerialNumberInput from "./input/SerialNumberInput";
import LoyaltyIDInput from "./input/LoyaltyIDInput";
import ReferenceNumberInput from "./input/ReferenceNumberInput";
import CalendarInput from "./input/CalendarInput";
import ClaimTypeSelector from "./input/ClaimTypeSelector";
import PumpManufacturerSelector from "./input/PumpManufacturerSelector";
import FailureTypeSelector from "./input/FailureTypeSelector";
import AdditionalCommentsInput from "./input/AdditionalCommentsInput";
import Alert from "./Alert";
import FileUpload from "./../button/FileUpload";
import ProductDescription from "./input/ProductDescription";
import SuggestedItemNumber from "./SuggestedItemNumber";
import { Typography } from "@mui/material";

const ClaimForm = ({
    uniqueWarrantyConstants,
    localized,
    itemNumberSubmit,
    itemNumberError,
    stockingType,
    returnPolicy,
    obsolete,
    needsValidation,
    itemNeedsValidation,
    setItemNumberSubmit,
    handleEnter,
    validateItemNumber,
    serialNumberSubmit,
    serialNumberWarning,
    serialNumberErrors,
    pioneerBrand,
    setSerialNumberSubmit,
    validateSerialNumber,
    loyaltyIDSubmit,
    loyalityIDWarning,
    setLoyaltyIDSubmit,
    referenceNumberSubmit,
    referenceNumberError,
    setReferenceNumberSubmit,
    dateInstalledSubmit,
    installDateError,
    minDate,
    updateDateInstalled,
    dateFailedSubmit,
    failureDateError,
    updateDateFailed,
    claimType,
    setClaimType,
    fetching,
    canAdd,
    fetchingAsync,
    claimTypeOptionError,
    itemDispositions,
    isPioneerItem,
    isMissingSerial,
    setMissingSerial,
    claimLines,
    uploadClaimAttachmentsToLocalClaimItem,
    duplicateSerial,
    isValidClaim,
    dateFormat,
    setDetailsCommentSubmit,
    detailComment,
    uploadFiles,
    productType,
    pumpManufacturer,
    setPumpManufacturer,
    failureType,
    setFailureType,
    productDescription,
    illegitimateSerialNumber,
    recommendedItemNumber,
    locale,
    isSerialNumberBypass,
    warrantyDescription
}) => {
    const renderAlerts = () => {
        if (returnPolicy === ".") {
            return <Alert type="error" message={localized.NonFasttrackNotAvailableError} />;
        }
        else if (returnPolicy === "N") {
            return <Alert type="error" message={localized.NonWarrantableError} />;
        }
        else if ((obsolete || stockingType === "U") && itemNumberSubmit.length > 0) {
            if (returnPolicy === "F") {
                return <Alert type="warning" message={localized.ObsoleteFastTrackWarning} />;
            } else {
                return <Alert type="error" message={localized.ObsoleteNonFastTrackError} />;
            }
        }
        if (duplicateSerial) {
            return <Alert type="error" message={localized.DuplicateSerialNumberInCart} />;
        }

        if (isValidClaim) {
            return <Alert type="error" message={localized.DuplicateSerialNumberOnClaimSubmit} />;
        }
        return null;
    };

    const handleRecommendItemNumberUpdate = (itemNumber) => {
        setItemNumberSubmit(itemNumber);
        validateItemNumber({ target: { value: itemNumber } });
    };

    return (
        <Col style={{ paddingRight: "3rem" }}>
            <div>
                <Row>
                    <Col style={{ marginBottom: "1.5rem", marginRight: "3rem" }}>
                        <FormSection label={localized.LoyaltyID}>
                            <LoyaltyIDInput
                                loyaltyIDSubmit={loyaltyIDSubmit}
                                needsValidation={needsValidation}
                                loyalityIDWarning={loyalityIDWarning}
                                setLoyaltyIDSubmit={setLoyaltyIDSubmit}
                                handleEnter={handleEnter}
                                localized={localized}
                            />
                        </FormSection>
                        <Row>
                            <Col>
                                <FormSection label={localized.ItemNumber} required>
                                    <ItemNumberInput
                                        itemNumberSubmit={itemNumberSubmit}
                                        itemNumberError={itemNumberError}
                                        returnPolicy={returnPolicy}
                                        obsolete={obsolete}
                                        needsValidation={needsValidation}
                                        itemNeedsValidation={itemNeedsValidation}
                                        setItemNumberSubmit={setItemNumberSubmit}
                                        handleEnter={handleEnter}
                                        validateItemNumber={validateItemNumber}
                                    />
                                    {!fetching ?
                                        <Typography
                                            sx={{
                                                display: "-webkit-box",
                                                WebkitBoxOrient: "vertical",
                                                overflow: "hidden",
                                                textOverflow: "ellipsis",
                                                WebkitLineClamp: 2,
                                                lineClamp: 2,
                                            }}
                                            style={{
                                                fontFamily: '"Gotham XNarrow SSm A", "Gotham XNarrow SSm B"',
                                                fontSize: "1.4rem",
                                                color: "blue"
                                            }}
                                        >
                                            {warrantyDescription}
                                        </Typography> : <></>}
                                </FormSection>                  
                            </Col>

                            <ProductDescription
                                label={localized.ItemDescription}
                                productDescription={productDescription}
                                fetching={fetching}
                            />                          
                        </Row>                       
                        <Row>
                            <Col>
                                <SuggestedItemNumber
                                    onUpdateItemNumber={handleRecommendItemNumberUpdate}
                                    itemNumber={itemNumberSubmit}
                                    recommendedItemNumber={recommendedItemNumber}
                                    localized={localized}
                                />
                            </Col>
                        </Row>

                        <div
                            style={
                                isSerialNumberBypass
                                    ? { display: "flex", flexDirection: "row", gap: "1rem" }
                                    : {}
                            }
                        >
                            <FormSection
                                inLineStyle={{ width: "100%" }}
                                label={localized.SerialNumber}
                                required={
                                    !pioneerBrand?.shown ||
                                    pioneerBrand.required !== false ||
                                    isMissingSerial === false
                                }
                                toolTipMsg={localized.SerialNoHoverTipMsg}
                            >
                                <SerialNumberInput
                                    isMissingSerial={isMissingSerial}
                                    serialNumberSubmit={serialNumberSubmit}
                                    serialNumberWarning={serialNumberWarning}
                                    serialNumberErrors={serialNumberErrors}
                                    pioneerBrand={pioneerBrand}
                                    needsValidation={needsValidation}
                                    localized={localized}
                                    setSerialNumberSubmit={setSerialNumberSubmit}
                                    handleEnter={handleEnter}
                                    validateSerialNumber={validateSerialNumber}
                                    itemNumberSubmit={itemNumberSubmit}
                                    illegitimateSerialNumber={illegitimateSerialNumber}
                                    isSDCItem={uniqueWarrantyConstants.find(
                                        (x) => x == itemNumberSubmit
                                    )}
                                />
                            </FormSection>

                            {isSerialNumberBypass &&
                                !uniqueWarrantyConstants.find((x) => x == itemNumberSubmit) &&
                                (
                                    <FormSection label={localized.IsMissingSerial}>
                                        <input
                                            type="checkbox"
                                            checked={isMissingSerial}
                                            onChange={() => setMissingSerial(!isMissingSerial)}
                                        />
                                    </FormSection>
                                )}
                        </div>

                       
                        <FormSection
                            className="claim-refNo"
                            label={localized.ReferenceNumber}
                            toolTipMsg={localized.RefNoHoverTipMsg}
                            required
                        >
                            <ReferenceNumberInput
                                referenceNumberSubmit={referenceNumberSubmit}
                                referenceNumberError={referenceNumberError}
                                needsValidation={needsValidation}
                                setReferenceNumberSubmit={setReferenceNumberSubmit}
                                handleEnter={handleEnter}
                            />
                        </FormSection>
                    </Col>

                    <Col>
                        <FormSection
                            label={localized.DateInstalled}
                            required={!isPioneerItem ? true : false}
                            datacy="dateInstalled-submit"
                        >
                            <CalendarInput
                                date={dateInstalledSubmit}
                                dateError={installDateError}
                                minDate={minDate}
                                needsValidated={needsValidation}
                                callBackFunction={updateDateInstalled}
                                showIcon={true}
                                pioneerBrand={pioneerBrand}
                                dateFormat={dateFormat}
                            />
                        </FormSection>

                        <FormSection
                            label={localized.DateFailed}
                            required={!isPioneerItem ? true : false}
                            datacy="dateFailed-submit"
                        >
                            <CalendarInput
                                date={dateFailedSubmit}
                                dateError={failureDateError}
                                minDate={minDate}
                                needsValidated={needsValidation}
                                callBackFunction={updateDateFailed}
                                showIcon={true}
                                pioneerBrand={pioneerBrand}
                                dateFormat={dateFormat}
                            />
                        </FormSection>

                        <FailureTypeSelector
                            failureType={failureType}
                            setFailureType={setFailureType}
                            localized={localized}
                            productType={productType}
                            locale={locale}
                            needsValidation={needsValidation}
                        />

                        <PumpManufacturerSelector
                            pumpManufacturer={pumpManufacturer}
                            setPumpManufacturer={setPumpManufacturer}
                            localized={localized}
                            productType={productType}
                            needsValidation={needsValidation}
                        />

                        <ClaimTypeSelector
                            localized={localized}
                            returnPolicy={returnPolicy}
                            obsolete={obsolete}
                            isPioneerItem={isPioneerItem}
                            itemDispositions={itemDispositions}
                            claimType={claimType}
                            setClaimType={setClaimType}
                            fetching={fetching}
                            canAdd={canAdd}
                            fetchingAsync={fetchingAsync}
                            needsValidation={needsValidation}
                            claimTypeOptionError={claimTypeOptionError}
                        />
                    </Col>
                </Row>

                <Row>
                    <Col>
                        <FormSection
                            label={localized.AdditionalComments}
                            subLabel={localized.AdditionalCommentsSubLabel}
                            required={failureType.isCommentsRequired}
                        >
                            <AdditionalCommentsInput
                                required={failureType.isCommentsRequired}
                                needsValidation={needsValidation}
                                setDetailsCommentSubmit={setDetailsCommentSubmit}
                                detailComment={detailComment}
                                editable={false}
                            />
                        </FormSection>
                    </Col>
                </Row>

                <FileUpload
                    isMissingSerial={isMissingSerial}
                    isPioneerItem={isPioneerItem}
                    localized={localized}
                    files={uploadFiles}
                    uploadClaimAttachmentsToLocalClaimItem={
                        uploadClaimAttachmentsToLocalClaimItem
                    }
                    claimLine={claimLines}
                />

                {renderAlerts()}
            </div>
        </Col>
    );
};

export default ClaimForm;
